'use client';

import { defaultProcessText } from 'app/utility/textProcessing';
import { IImage } from 'app/interfaces/common';
import ImageBg from 'app/components/common/ImageBg';

export interface IReviewCardProps {
  text: string;
  authorName: string;
  avatar?: IImage | null;
  date?: string;
  image?: IImage | null;
}

export default function ReviewCard({
  text,
  authorName,
  avatar,
  date,
  image
}: IReviewCardProps) {
  return (
    <div className="grid xl:grid-cols-2 gap-y-17 md:gap-y-22 xl:gap-x-5 md:pr-31 xl:pr-0 group">
      <div className="relative hidden xl:block w-[215px] h-[336px] overflow-hidden rounded">
        {!!image && (
          <ImageBg
            src={image.url}
            alt={image.alt ?? ''}
            fill
            placeholderDataURL={image.placeholder_data_url}
            className="object-cover rounded"
          />
        )}
      </div>
      <div className="relative flex flex-col gap-2.5 md:gap-5 xl:pl-9">
        <div className="relative xl:absolute xl:top-0 xl:-left-9 xl:-translate-x-1/2 w-13 h-16 overflow-hidden rounded">
          {!!avatar && (
            <ImageBg
              src={avatar.url}
              alt={avatar.alt ?? ''}
              fill
              placeholderDataURL={avatar.placeholder_data_url}
              className="object-cover rounded-md"
            />
          )}
        </div>
        <div
          className="md:w-[580px] text-p1 text-sand"
          dangerouslySetInnerHTML={{
            __html: defaultProcessText(text)
          }}
        />
      </div>
      <div className="flex flex-col md:flex-row md:flex-wrap gap-1.5 md:gap-23 pr-26 md:pr-0">
        <div className="text-h1 text-sand">{authorName}</div>
        <div className="text-p3 md:text-h1 md:text-sand xl:hidden">{date}</div>
      </div>
      <div className="text-p3 md:text-h1 md:text-sand hidden xl:block xl:pl-9">
        {date}
      </div>
    </div>
  );
}
